import { z } from 'zod';

export const couplerSchema = z.object({
  text: z.string().min(1),
  location: z.string(),
  portCount: z.number().int().min(1),
  unitType: z.string(),
});

export type CouplerSchema = z.infer<typeof couplerSchema>;
